import { useEffect, useState } from 'react';
import { ImmutableStopwatchInfo } from '../../classes/timeTracking/ImmutableStopwatch/ImmutableStopwatch';
import { useStopwatchManager } from './useStopwatchManager';

export function useStopwatchInfos(): Array<ImmutableStopwatchInfo> {
  const manager = useStopwatchManager();

  const [infos, setInfos] = useState<Array<ImmutableStopwatchInfo>>(
    manager.getStopwatchInfos()
  );

  useEffect(() => {
    const disposable = manager.onStopwatchInfosChanged(setInfos);
    return () => disposable.dispose();
  }, [manager, setInfos]);

  return infos;
}
